import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../components/util/Loading';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../supabaseClient';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { logIn } = useAuth();
  const mode = new URLSearchParams(search).get('mode'); // 'signup' or 'signin'

  useEffect(() => {
    // 공통: 세션 가져오기
    const getSession = async () => {
      const {
        data: { session },
        error: sessionError,
      } = await supabase.auth.getSession();
      if (sessionError || !session) {
        navigate('/login');
        return null;
      }
      return session;
    };

    const handleGoogleSignUp = async () => {
      const session = await getSession();
      console.log('session', session);

      if (!session) return;
      const { id: google_uuid, email, user_metadata } = session.user;
      const name = user_metadata?.name ?? '';

      const { data: member, error: selectError } = await supabase
        .from('tb_member')
        .select('member_seq')
        .eq('google_uuid', google_uuid)
        .single();

      if (selectError && selectError.code !== 'PGRST116') {
        console.error('회원 조회 중 에러', selectError);
        return;
      }
      if (member) {
        logIn(session.user);
        navigate('/store/home');
        return;
      }
      const { error: insertError } = await supabase
        .from('tb_member')
        .insert({ google_uuid, name, email });
      if (insertError) {
        console.error('회원 등록 실패', insertError);
        return;
      }

      navigate('/store/home');
    };

    const handleGoogleSignIn = async () => {
      const session = await getSession();
      if (!session) return;
      const { id: google_uuid } = session.user;
      console.log('google_uuid', google_uuid);
      const { data: member, error: selectError } = await supabase
        .from('tb_member')
        .select('member_seq')
        .eq('google_uuid', google_uuid)
        .single();

      if (selectError && selectError.code !== 'PGRST116') {
        console.error('회원 조회 중 에러', selectError);
        return;
      }

      if (member) {
        console.log('회원 조회 성공', member);
        logIn(session.user);
        navigate('/store/home');
      } else {
        navigate('/login');
      }
    };

    if (mode === 'signup') {
      handleGoogleSignUp();
    } else {
      handleGoogleSignIn();
    }
  }, [navigate, mode, logIn]);

  return (
  <div className="container">
    <Loading message="로그인 중입니다..." />
  </div>
  );
};

export default AuthCallback;